import React, { useState, useEffect, useRef } from 'react'
import Slider from "react-slick";
import styles from '../../utilities/OurStory/OurStory.module.css'
// import Modal from '@/utilities/SciencePage/ModalSciencePage/Modal';
const OurStory = () => {
    const sliderRef = useRef(null);

    const nextSlide = () => {
        sliderRef.current.slickNext();
    };

    const prevSlide = () => {
        sliderRef.current.slickPrev();
    };

    const settings = {
        dots: false,
        infinite: true,
        speed: 1500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    const slidesData = [
        {
            title: " Market",
            text: "Bruno MD creates solutions that enhance lives, extending beyond pharmaceuticals. The company is passionate about developing natural supplements as part of its commitment to health and wellness. By focusing on both traditional and alternative methods, Bruno MD aims to provide effective, holistic solutions. The company strives to offer products that support overall well-being. Their innovative approach reflects a dedication to improving quality of life through science and nature. This commitment sets Bruno MD apart in the health industry.",
            image1: "images/Slide-01 574x626.webp",
            videoSrc: "/images/01_RED_A005.mp4",
            quote: "We have a very good opportunity to develop extremely good food supplements based on Italian-sourced ingredients.",
            quoteAuthor: "- Dr. Vincenzo Bruno"
        },
        {
            title: "Sources",
            text: "Bruno MD sources the finest ingredients grown on Italian soil. For ingredients that cannot be cultivated locally, the brand selects them from small, family-run farms across the globe. This commitment ensures the highest quality and authenticity in every product. Each ingredient is carefully chosen to provide the best results. Bruno MD values sustainable farming practices and supports local communities. The result is a product line rooted in excellence and ethical sourcing.",
            image1: "images/Slide-02_574x626.webp",

            videoSrc: "/images/04_RED_A005.mp4",
            quote: "Selecting the best sources of ingredients in Italy? That is hard. We have many, many places where you can take blood oranges from, but selecting the best ones, in my opinion, that is medical art.",
            quoteAuthor: " - Dr. Vincenzo Bruno"
        },
        {
            title: "Affordability",
            text: "Affordability is at the core of Bruno MD’s mission. The company focuses on converting natural ingredients into effective, affordable treatments for patients. By using the highest-quality natural ingredients, Bruno MD strives to deliver the greatest benefit at the lowest cost. This approach ensures that patients receive optimal care without financial strain. Bruno MD’s commitment to affordability is essential in providing accessible healthcare solutions. Their dedication to quality and cost-effectiveness makes them a trusted choice for medical supplements.",
            image1: "images/Slide-03_574x626.webp",
            videoSrc: "/images/03_RED_A005.mp4",
            quote: "Developing [natural ingredients] into medical supplements also means for us creating products to be available and affordable for any one.",
            quoteAuthor: "- Dr. Vincenzo Bruno"
        },
        {
            title: "Purpose",
            text: "Italy is renowned worldwide for its fashion and design, but it is also celebrated for its fresh, abundant ingredients that promote longevity and health. These ingredients are central to the Mediterranean lifestyle, which is known for its numerous health benefits. Our purpose is to harness these natural advantages in a medical supplement. By combining Italy’s rich culinary heritage with modern science, we aim to support overall well-being and longevity. Our goal is to provide a product that reflects the essence of this healthy, time-tested lifestyle.",
            image1: "images/Slide04_0757+574x626_.webp",
            videoSrc: "/images/02_RED_A005.mp4",
            quote: "That is my, our final purpose: telling the world that made in Italy is not only linked to fashion and lifestyle, but also to medical supplements.",
            quoteAuthor: "- Dr. Vincenzo Bruno",
        },

    ];


    return (
        <section id="aboutPage" className={styles.sliderContainer}>
            <Slider {...settings} ref={sliderRef}>
                {slidesData.map((slide, index) => (
                    <div className={styles.aboutMain} key={index}>
                        <div className={styles.part1}>
                            <img src={slide.image1} alt={`Slide ${index + 1}`} />
                        </div>
                        <div className={styles.part2}>
                            <div className={styles.Part2_Scroll}>
                                <h2>{slide.title}</h2>
                                <p>{slide.text}</p>
                            </div>
                            <div className={styles.dottedDiv}>
                                <p>
                                    &#34;{slide.quote}&#34; <br/> <b>{slide.quoteAuthor}</b>
                                </p>
                            </div>
                        </div>
                        <div className={styles.part3}>
                            <div className={styles.vidful}>
                                <video width="" height="100%" muted autoPlay={true} playsInline loop>
                                    <source src={slide.videoSrc} type="video/mp4" />
                                    <source src={slide.videoSrc} type="video/ogg" />
                                </video>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>

            {/* Custom Button Wrapper Div */}
            <div className={styles.btnWrap}>
                <div className={styles.custom_btnDiv}>
                    {/* Custom Previous Button */}
                    <button
                        onClick={prevSlide}
                        className={`${styles.sliderButton} ${styles.prev_button}`}
                    >
                        <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.1641 26L45.4974 26" stroke="#7F7F7F" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M4.68932 26.2144L13.9538 31.773C14.487 32.093 15.1654 31.7089 15.1654 31.087L15.1654 20.913C15.1654 20.2911 14.487 19.907 13.9538 20.227L4.68932 25.7856C4.52749 25.8827 4.52749 26.1173 4.68932 26.2144Z" fill="#7F7F7F" />
                        </svg>
                    </button>

                    {/* Custom Next Button */}
                    <button
                        onClick={nextSlide}
                        className={`${styles.sliderButton} ${styles.next_button}`}
                    >
                        <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M37.832 26.832L7.50234 27.3025" stroke="#7F7F7F" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M48.3027 26.4545L38.9532 21.0402C38.4151 20.7285 37.7427 21.1231 37.7524 21.7449L37.9102 31.9177C37.9198 32.5395 38.6041 32.913 39.1323 32.5849L48.3094 26.8832C48.4697 26.7836 48.4661 26.5491 48.3027 26.4545Z" fill="#7F7F7F" />
                        </svg>
                    </button>
                </div>
            </div>
        </section>
    )
}

export default OurStory
